"use strict";
exports.__esModule = true;
exports.PartyType = exports.UserRoleType = void 0;
var UserRoleType;
(function (UserRoleType) {
    UserRoleType["ADMIN"] = "ADMIN";
})(UserRoleType = exports.UserRoleType || (exports.UserRoleType = {}));
var PartyType;
(function (PartyType) {
    PartyType["PLATFORM"] = "PLATFORM";
    PartyType["MERCHANT"] = "MERCHANT";
    PartyType["PRODUCER"] = "PRODUCER";
})(PartyType = exports.PartyType || (exports.PartyType = {}));
